/**
 * Section B7.6 Service - B.7.6.事前排放減量總和
 * Summary of ex ante estimates of emission reductions/net removals
 */
import axios from '../api/axios';

const BASE_URL = '/api/section-b7-6';

export interface SummaryRow {
  id: string;
  year_label: string;
  baseline_emissions:  number | null;
  project_emissions:   number | null;
  leakage_emissions:   number | null;
  emission_reductions: number | null;
}

export interface SectionB76Detail {
  id: number;
  organization_id: number;
  project_id: number;
  rows: SummaryRow[] | null;
  total_years: number | null;
  section_c_complete: boolean;
  total_years_default: number | null;
  crediting_period_start: string | null;
  b7_6: number;
  edit_by: number;
  created_at: string | null;
  updated_at: string | null;
}

export interface SectionB76Update {
  rows: SummaryRow[];
  total_years: number | null;
}

export const getSectionB76ByProject = async (projectId: number): Promise<SectionB76Detail | null> => {
  const res = await axios.get<SectionB76Detail>(`${BASE_URL}/by-project/${projectId}`);
  return res.data;
};

export const saveSectionB76 = async (projectId: number, payload: SectionB76Update): Promise<SectionB76Detail> => {
  const res = await axios.put<SectionB76Detail>(`${BASE_URL}/${projectId}`, payload);
  return res.data;
};

export const resetSectionB76 = async (projectId: number): Promise<void> => {
  await axios.post(`${BASE_URL}/${projectId}/reset`);
};

export const importFromXlsx = async (projectId: number, file: File): Promise<SummaryRow[]> => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await axios.post<SummaryRow[]>(`${BASE_URL}/${projectId}/import-xlsx`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

const sectionB76Service = { getSectionB76ByProject, saveSectionB76, resetSectionB76, importFromXlsx };
export default sectionB76Service;
